// Match enum GameActionEnum back
export const enum GameActionEnum {
    join = "join",
    quit = "quit",
    stop = "stop",
    validTeam = "validTeam",
    updateScore = "updateScore",
    confirmScore = "confirmScore",
}
